
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12.193 18v-6.842h2.358l.353-2.667h-2.711V6.79c0-.772.22-1.298 1.357-1.298L15 5.49V3.105A19.926 19.926 0 0012.887 3c-2.091 0-3.522 1.243-3.522 3.525V8.49H7v2.667h2.365V18H.993A.99.99 0 010 17.014V.986A.99.99 0 01.993 0h16.013A.99.99 0 0118 .986v16.17c0 .545-.445.844-.993.844h-4.814z","fill":"#70767C","fill-rule":"evenodd"}})])
      }
    
      }
    